// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Zone from "@insite/client-framework/Components/Zone";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Modals from "@insite/content-library/Components/Modals";
import ProductCompareFlyOut from "@insite/content-library/Components/ProductCompareFlyOut";
import Page, { PageProps as MobiusPageProps } from "@insite/mobius/Page";
import React from "react";

type Props = PageProps;

export interface ReorderPadPageStyles {
    page?: MobiusPageProps;
}

export const reorderPadPageStyles: ReorderPadPageStyles = {};

const styles = reorderPadPageStyles;

const ReorderPadPage = ({ id }: Props) => {
    return (
        <Page data-test-selector="ReorderPadPage" {...styles.page}>
            <Zone contentId={id} zoneName="Content" />
            <Modals />
            <ProductCompareFlyOut />
        </Page>
    );
};

const pageModule: PageModule = {
    component: ReorderPadPage,
    definition: {
        displayName: "Reorder Pad",
        hasEditableTitle: true,
        hasEditableUrlSegment: false,
        pageType: "System",
    },
};

export default pageModule;
